import {PropsWithChildren, ComponentType} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const baseCss = css`
  font-weight: 500;
  letter-spacing: auto;
  color: ${COLORS.Black};
`;

export type Alignment = 'left' | 'center' | 'right' | 'justify';

export type TextProps = PropsWithChildren<{
  size?: keyof typeof FONT_SIZES;
  color?: keyof typeof COLORS | 'inherit';
  weight?: keyof typeof FONT_WEIGHTS;
  transform?: 'lowercase' | 'uppercase' | 'capitalize' | 'none';
  striked?: boolean;
  className?: string;
  as?: keyof JSX.IntrinsicElements | ComponentType<PropsWithChildren>;
  textAlignment?: Alignment;
  dangerouslySetInnerHTML?: {__html: string};
}>;

export const Text = styled.span<TextProps>`
  ${baseCss};
  font-size: ${({size = 'px14'}) => FONT_SIZES[size]};
  ${({transform}) =>
    transform &&
    css`
      text-transform: ${transform};
    `};
  ${({color}) =>
    color &&
    css`
      color: ${color === 'inherit' ? 'inherit' : COLORS[color]};
    `};
  ${({weight}) =>
    weight &&
    css`
      font-weight: ${FONT_WEIGHTS[weight]};
    `};
  ${({striked}) =>
    striked &&
    css`
      text-decoration: line-through;
    `}
  ${({textAlignment}) =>
    textAlignment &&
    css`
      text-align: ${textAlignment};
    `}
`;
